<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">Export data Konsumen</div>
      <div v-if="loading == true">
        <loading></loading>
      </div>
      <div class="card-body" v-if="loading == false">
        <div class>
          <b-button
            size="sm"
            variant="stack-overflow"
            class="mr-1 btn-brand"
            v-on:click="openUpload()"
          >
            <i class="fa fa-upload"></i>
            <span>Upload SO</span>
          </b-button>
        </div>
        <br />
        <table v-if="myData" class="table table-hover table-bordered table-striped table-sm">
          <tbody>
            <template v-for="(value, date) of myData">
              <tr v-bind:key="date+uniqueId('title')">
                <td colspan="3">{{date}}</td>
              </tr>
              <tr v-bind:key="'prnt2_'+date">
                <td>Product</td>
                <td>Delivery</td>
                <td>Retur</td>
              </tr>
              <template v-for="(child_val, key) of myData[date]">
                <tr v-bind:key="key+uniqueId('data')">
                  <td>{{key}}</td>
                  <td>{{child_val.Delivery}}</td>
                  <td>{{(child_val.Retur !== undefined) ? child_val.Retur : 0}}</td>
                </tr>
              </template>

              <tr v-bind:key="'prnt3_'+date">
                <td colspan="3">&nbsp;</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>

    <b-modal
      ref="uploadExcell"
      id="addModalsByExcell"
      header-border-variant="no-border text-center"
      footer-border-variant="no-border"
      footer-bg-variant="light"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="lg"
    >
      <div slot="modal-header" class="text-center">
        <h3 class="text-center">Form Upload Order</h3>
      </div>

      <b-form id="uploadOrderForm" validated novalidate>
        <b-row v-if="!formLoading">
          <b-col sm="4">
            <b-form-group label-for="file" label="Upload Excel">
              <b-form-file
                ref="inputDocument"
                accept=".xls, .xlsx, .csv"
                @change="OnUploadSelect($event)"
                v-model="uploadOrderForm.file"
                required
              ></b-form-file>
              <div
                v-if="uploadOrderForm.file === null || uploadOrderForm.file === undefined"
                class="invalid-feedback-custom"
              >Upload order anda dalam format excel.</div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col>
            <loading></loading>
          </b-col>
        </b-row>
      </b-form>

      <div slot="modal-footer" class="float-right">
        <div v-if="!formLoading">
          <b-button type="button" size="sm" variant="danger" @click="cancelUpload">
            <i class="fa fa-undo"></i> Back
          </b-button>&nbsp;
          <b-button
            type="button"
            size="sm"
            variant="primary"
            @click="processUploadOrder"
            :disabled="$v.uploadOrderForm.$invalid"
          >
            <i class="fa fa-save"></i> Save
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import loading from "@/templates/Loading.vue";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import _ from "lodash";

export default {
  name: "calculate-so",
  components: {
    loading
  },
  data() {
    return {
      uploadOrderForm: { file: null },
      myData: [],
      loading: false,
      formLoading: false,
      uploadListExcell: ["xls", "xlsx", "csv"]
    };
  },
  validations: {
    uploadOrderForm: {
      file: { required }
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    uniqueId: function(param = "") {
      return _.uniqueId(param);
    },
    init: function() {
      this.loading = false;
    },
    openUpload: function() {
      this.$refs.uploadExcell.show();
      this.resetFormUploadForm();
    },
    cancelUpload: function() {
      this.resetFormUploadForm();
      this.$refs.uploadExcell.hide();
    },
    OnUploadSelect: function(event) {
      const file = event.target.files[0];
      const fileArray = file.name.split(".");
      const totalArray = fileArray.length - 1;
      if (this.uploadListExcell.includes(fileArray[totalArray])) {
        this.uploadOrderForm.file = event.target.files[0];
      } else {
        this.resetFormUploadForm();
      }
    },
    processUploadOrder: function(evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin menghitung SO ini ?")) {
        this.formLoading = true;
        let uploadOrder = new FormData();
        uploadOrder.append("file", this.uploadOrderForm.file);
        this.axios
          .post("web/upload_raw/so/", uploadOrder)
          .then(response => {
            this.myData = response.data.data;
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Calculate SO",
                message: 'Data berhasil di olah'
              });
            }
          })
          .catch(error => {
            this.expired(error, "Upload Order");
          })
          .finally(() => {
            this.$refs.uploadExcell.hide();
            this.init();
          });
      }
      //console.log(this.uploadOrderForm);
    },
    resetFormUploadForm: function() {
      this.formLoading = false;
      //this.$refs["inputDocument"].reset();
      this.$refs["inputDocument"].reset();
      this.uploadOrderForm.file = null;
    },
    expired: function(error, title) {
      console.log(error);
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
</style>
